// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2vIyh","box":"WorkspacesBox_box__2hTFV","node":"WorkspacesBox_node__19-rl"};